import { ANALYTICS_EVENTS } from '@web-platform/shared-universal-constants-tracking';

export const allowedBehaviouralEvents = [
  'booking_panel_baggage_badge',
  'booking_panel_filter_button',
  'booking_panel_save_to_list_interaction',
  'booking_panel_upsell_button',
  'booking_panel',
  'bp_agent_fares_list_go_to_site',
  'bp_agent_fares_list',
  'mock_behavioural_event',
  'mock_trackBehaviouralEvent',
  'price_grid_cell_click',
  'price_grid_date_search',
  'price_grid_direct_flights_toggle',
  'price_grid_find_flights_click',
  'price_grid_opened_mini_grid',
  'price_grid_search_results',
  'user_clicked_mini_grid_date',
  ANALYTICS_EVENTS.MIXED.MASHUP_FARE_AVAILABLE.NAME,
  ANALYTICS_EVENTS.MIXED.RAIL_BANNER_CLICKED.NAME,
  ANALYTICS_EVENTS.MIXED.RAIL_BANNER_LOADED.NAME,
  ANALYTICS_EVENTS.MIXED.RAIL_DRAWER_CLOSED.NAME,
  ANALYTICS_EVENTS.MIXED.RAIL_DRAWER_OPENED.NAME,
  ANALYTICS_EVENTS.MIXED.RAIL_ITINERARY_CLICKED.NAME,
  ANALYTICS_EVENTS.MIXED.RAIL_SEE_MORE_CLICKED.NAME,
  ANALYTICS_EVENTS.MIXED.SECONDARY_SORT_SELECTED.NAME,
] as const;

export type AllowedBehaviouralEventName = (typeof allowedBehaviouralEvents)[number];
